import { useAtomValue, WritableAtom } from 'jotai'
import { useEffect } from 'react'

type TUseSyncFieldWithAtomProps<T> = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	atom: WritableAtom<T, any, any>
	setFieldValue: (value: T) => void
}

export const useSyncFieldWithAtom = <T>(
	props: TUseSyncFieldWithAtomProps<T>,
	deps?: unknown[],
) => {
	const { atom, setFieldValue } = props
	
	const value = useAtomValue(atom)

	useEffect(() => {
		setFieldValue(value)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value, ...(deps || [])])
}
